export default __webpack_public_path__ + "static/media/city-picture.0b07ca10.svg";